import { MLChannel, MLEvent, MLEventType, MLItemType, MLResultType, MLSearchType, MLSort, MLStore } from '@machine-learning/data-access';
import { ProductList, ProductVO, SearchVO } from '@plp/data-access/interfaces';

import { EmptyHomrBannerData } from './product-list-state.mock';

export const ProductListMock: ProductList = {
	totalCount: 1,
	searchVO: {
		searchTerm: 'foo',
		selectedCategory: '12301_1349072',
		selectedStore: '302',
		selectedSort: 5,
		selectedFilters: {},
		snbAudience: 'FizzBuzz',
		storeId: 15108,
		pageNumber: 0,
		pageSize: 48,
		totalCount: 1,
		searchTypes: [
			'RISA',
			'PINNING'
		],
		isFamilyPage: true
	},
	fuzzyMatch: false,
	myStoreZero: false,
	priceFilterZero: false,
	mlBypass: false,
	productVOs: [
		{
			catentryId: 10753829,
			partnumber: '25209537',
			parentCatentryId: '10752719',
			parentPartnumber: '23NIKMMNKCLBFLWSHNLB',
			name: 'Nike Men\'s Club 6\'\' Woven Flow Shorts',
			mfName: 'Nike',
			fullImage: '23NIKMMNKCLBFLWSHNLB',
			assetSeoUrl: '/p/nike-mens-club-6-woven-flow-shorts-23nikmmnkclbflwshnlb/23nikmmnkclbflwshnlb',
			dsgSeoUrl: '/p/nike-mens-club-6-woven-flow-shorts-23nikmmnkclbflwshnlb/23nikmmnkclbflwshnlb',
			dsgProductSortDate: '10/26/2023',
			attributes: '[{"X_BRAND":"Nike"},{"PRIMARY_CATEGORY_DSG ":"MensShorts-129829"},{"5495":"Men\'s"},{"5382":"Shorts"},{"4285":"Casual"},{"X_BazaarVoice_ratings_DSG":4.7576},{"X_BazaarVoice_ratings_ovr_DSG":4.7576},{"X_BazaarVoice_count_DSG":99},{"X_BazaarVoice_count_ovr_DSG":99},{"X_BazaarVoice_q_count_DSG":1},{"X_BazaarVoice_a_count_DSG":0},{"2101":"Men\'s"},{"4547":"Shorts"},{"4004":"Athletic"},{"4980":"Short"},{"4139":"6"},{"3318":"600-024-013-002"},{"3695":"Imported"},{"5733":"Yes"},{"3290":"FN3307"},{"4482":"Y"},{"3396":"1577"},{"3961":"True"},{"4634":"FN3307"},{"4474":"10/26/2023"},{"4723":"Y"},{"4875":"promo-new-markdown"},{"4875":"Gifts for Him"},{"4875":"Gifts for Her"},{"4875":"promo-flash-sale"},{"4875":"womens-apparel-gifts"},{"5333":"100% polyester"},{"5426":"Regular fit| Relaxed through seat and thighs| Hits above the knee"}]',
			floatFacets: [],
			dsgPriceIndicators: {
				dealsPercentage: 26.02,
				mapPriceIndicator: 0,
				priceIndicator: 0
			},
			ratingValue: 4.7576,
			ratingCount: 99,
			quickViewEnabled: true,
			isPinned: true,
			isComingSoon: false
		}
	],
	productDetails: {
			['10752719']: {
			prices: {
				maxlistprice: '50.00',
				minofferprice: '21.97',
				minlistprice: '50.00',
				maxofferprice: '37.50'
			},
			skuAttributes: {
				Color: [
					'Burgundy Crush',
					'Lightening',
					'Malachite',
					'Pink Foam',
					'Viotech',
					'Dusty Cactus',
					'Fir',
					'Flax',
					'Game Royal',
					'Midnight Navy',
					'Oil Green',
					'Playful Pink',
					'Pure Platinum',
					'University Red',
					'Black'
				]
			},
			priceIndicator: 0,
			mapPriceIndicator: 0
		}
	},
	facetVOs: [
		{
			attrIdentifier: 'X_BRAND',
			attrName: 'Brand',
			facetSelection: 1,
			valueList: [{
				count: 1,
				value: 'Columbia',
			}],
			values: new Map([['Columbia', 1]])
		}
	],
	conversationFacetVOs: [],
	categoryDetails: {
		['12301_202045']: {
			imgSrc: 'https://dks.scene7.com/is/image/dkscdn/22PTGMMSLWSYNCHSNAPO_Belay_Blue?$DSG_ProductCard$',
			thumbnail: '',
			name: 'Jackets & Vests',
			url: '/f/mens-jackets-vests',
			topResultFullImage: '22PTGMMSLWSYNCHSNAPO',
			topResultThumbnail: '22PTGMMSLWSYNCHSNAPO_Belay Blue'
		},
		['12301_202044']: {
			imgSrc: 'https://dks.scene7.com/is/image/dkscdn/19NIKMMNSWCLBHDPBNFT_Ashen_Slate?$DSG_ProductCard$',
			thumbnail: '',
			name: 'Hoodies & Sweatshirts',
			url: '/f/hoodies-for-men',
			topResultFullImage: '19NIKMMNSWCLBHDPBNFT',
			topResultThumbnail: '19NIKMMNSWCLBHDPBNFT_Ashen Slate'
		},
		['12301_202047']: {
			thumbnail: '',
			name: 'Pants',
			url: '/f/mens-pants',
			topResultFullImage: '19NIKMMNSWCLBJGGRNFB',
			topResultThumbnail: '19NIKMMNSWCLBJGGRNFB_Burgundy Crush'
		},
		['12301_202046']: {
			name: 'Shorts',
			url: '/f/mens-shorts',
			thumbnail: '22TNOMMCTN6WVNSHRAPT_Shady_Blue',
			topResultFullImage: '23NIKMMNKCLBFLWSHNLB',
			topResultThumbnail: '23NIKMMNKCLBFLWSHNLB_Burgundy Crush'
		},
		['12301_202048']: {
			thumbnail: '',
			name: 'Men\'s Swimsuits',
			url: '/f/mens-swimsuits',
			topResultFullImage: '24HYHMTHTRTGS55CLGAL',
			topResultThumbnail: '24HYHMTHTRTGS55CLGAL_Apex Swimmers'
		},
		['12301_202050']: {
			name: 'Underwear',
			url: '/f/boxer-briefs-for-men',
			thumbnail: 'Underwear_faceout_feb_2017',
			topResultFullImage: '22NIKMBXRBRF3PKXXNUW',
			topResultThumbnail: '22NIKMBXRBRF3PKXXNUW_Black/Photo Blu'
		},
		['12301_1349072']: {
			thumbnail: '',
			name: 'Shop All Men\'s Clothing',
			url: '/f/view-all-mens-apparel',
			topResultFullImage: '19NIKMMNSWCLBJGGRNFB',
			topResultThumbnail: '19NIKMMNSWCLBJGGRNFB_Burgundy Crush'
		},
		['12301_298051']: {
			thumbnail: '',
			name: 'Fleece',
			url: '/f/mens-sweaters-fleece',
			topResultFullImage: '22PTGMMSLWSYNCHSNAPO',
			topResultThumbnail: '22PTGMMSLWSYNCHSNAPO_Belay Blue'
		},
		['12301_202042']: {
			thumbnail: '',
			name: 'Shirts & Tops',
			url: '/f/mens-shirts',
			topResultFullImage: '18UARMTCHSSTXXXXXAPTA',
			topResultThumbnail: '18UARMTCHSSTXXXXXAPTA_Academy/Steel Heather'
		}
	},
	homrBannerData: EmptyHomrBannerData,
	isProductListPageValid: true,
	pageNumber: 0,
	pinnedContent: [],
	piqProducts: [],
	productAvailability: null,
	productPromotion: null,
	selectedSort: 0,
	viewCount: 48,
	fulfillmentFacets: [
		{
			name: 'SHIP',
			count: 14
		},
		{
			name: 'SDD',
			count: 4
		},
		{
			name: 'BOPIS',
			count: 3
		}
	]
};

export const MockProductVO: ProductVO = {
	catentryId: 7565347,
	partnumber: '22663541',
	parentCatentryId: '5176301',
	parentPartnumber: '19CMBMMTPTNPKNSLTAPO',
	name: 'Columbia Men\'s Tipton Peak Insulated Jacket',
	mfName: 'Columbia',
	fullImage: '19CMBMMTPTNPKNSLTAPO',
	assetSeoUrl: '/p/columbia-mens-tipton-peak-insulated-jacket-19cmbmmtptnpknsltapo/19cmbmmtptnpknsltapo',
	dsgSeoUrl: '/p/columbia-mens-tipton-peak-insulated-jacket-19cmbmmtptnpknsltapo/19cmbmmtptnpknsltapo',
	dsgProductSortDate: '05/01/2019',
	attributes: '[{"X_BRAND":"Columbia"},{"PRIMARY_CATEGORY_FNS":"JacketsVests-116054"},{"PRIMARY_CATEGORY_DSG ":"MensJacketsVests-129828"},{"5495":"Men\'s"},{"5382":"Jackets"}]',
	floatFacets: [
		{
			identifier: 'X_BazaarVoice_ratings_DSG',
			stringValue: '4.5287',
			storeId: 10001,
			partnumber: '19CMBMMTPTNPKNSLTAPO',
			value: 4.5287,
			name: 'Customer Rating'
		}
	],
	dsgPriceIndicators: {
		dealsPercentage: 31.26,
		mapPriceIndicator: 0,
		priceIndicator: 0
	},
	ratingValue: 4.5287,
	ratingCount: 87,
	quickViewEnabled: true,
	isPinned: false,
	isComingSoon: false
};

export const MockSearchVO: SearchVO = {
	selectedCategory: '12301_202045',
	selectedSort: 0,
	selectedFilters: { 'X_BRAND': ['Foo', 'Bar'] },
	storeId: 15108,
	pageNumber: 0,
	pageSize: 48,
	totalCount: 766,
	searchTerm: 'foobar search',
	selectedStore: 'myStore',
	searchTypes: [],
	snbAudience: '',
	isFamilyPage: true
};

export const MockMLPageEventPayload: MLEvent = {
	channel: MLChannel.WEB,
	date: '2024-07-15',
	id: 'id',
	result: {
		facets: [],
		items: [{ id: '19CMBMMTPTNPKNSLTAPO', num: 1, type: MLItemType.PRODUCT }],
		took: 0,
		total: 1,
		type: MLResultType.NORMAL,
	},
	search: {
		category: MockSearchVO.selectedCategory,
		filters: [{ facet: 'X_BRAND', values: ['Foo', 'Bar'] }],
		page: MockSearchVO.pageNumber,
		size: MockSearchVO.pageSize,
		sort: MockSearchVO.selectedSort,
		type: MockSearchVO.isFamilyPage ? MLSearchType.PLP : MLSearchType.SRLP,
		term: ''
	},
	source: '/v2/search',
	store: MLStore.DSG,
	time: 1721016000000,
	track: {
		AdobeMCVID: 'AdobeMCVID',
		CustomerKey: 'CustomerKey',
		DeviceID: 'DeviceID',
		MCID: 'Master Customer ID',
		Loyalty: 'Loyalty',
		Webstore: 'Webstore'
	},
	type: MLEventType.SEARCH
};

export const MockClickEventData: MLEvent = {
	channel: MLChannel.WEB,
	click: {
		id: MockProductVO.parentPartnumber,
		num: 1,
		type: MLItemType.PRODUCT,
	},
	date: '2024-07-15',
	id: 'individualID',
	parentId: 'parentID',
	result: {
		facets: [{
			facet: 'X_BRAND',
			values: [{ count: 1, value: 'Columbia' }]
		}],
		flags: {
			mlBypass: false,
			mlGroup: '',
			mlRank: false,
			mlRewrite: false,
			mlSpelling: false
		},
		items: [
			{ id: MockProductVO.parentPartnumber, num: 1, type: MLItemType.PRODUCT },
			{ id: '16ADIGGDSTNYBLTDPBBA', num: 2, type: MLItemType.SPONSORED_PRODUCT },
			{ id: 'b9228187a7802024-12-26T16:15:70-8', num: 3, type: MLItemType.PINNED_CONTENT_SPOT }
		],
		took: 0,
		total: 1,
		type: MLResultType.NORMAL,
	},
	search: {
		category: '',
		filters: [
			{
				facet: 'brand',
				 values: ['Columbia']
			},
			{
				facet: 'color',
				values: ['Blue', 'Green', 'Red']
			},
			{
				facet: 'size',
				values: ['S', 'M', 'L']
			}
		],
		page: 0,
		size: 48,
		sort: MLSort.MOST_RELEVANT,
		term: 'foobar search',
		type: MLSearchType.SRLP
	},
	source: '/v2/search',
	store: MLStore.DSG,
	time: 1721059200000,
	track: {
		AdobeMCVID: 'AdobeMCVID',
		CustomerKey: 'CustomerKey',
		DeviceID: 'DeviceID',
		MCID: 'Master Customer ID',
		Loyalty: 'Loyalty',
		Webstore: 'Webstore'
	},
	type: MLEventType.CLICK
};

export const DISPLAYABLE_PRODUCT_LIST_DATA = {
	...ProductListMock.productVOs[0],
	prices: {
		maxlistprice: '50.00',
		minofferprice: '21.97',
		minlistprice: '50.00',
		maxofferprice: '37.50'
	},
	skuAttributes: {
		Color: [
			'Burgundy Crush',
			'Lightening',
			'Malachite',
			'Pink Foam',
			'Viotech',
			'Dusty Cactus',
			'Fir',
			'Flax',
			'Game Royal',
			'Midnight Navy',
			'Oil Green',
			'Playful Pink',
			'Pure Platinum',
			'University Red',
			'Black'
		]
	},
	priceIndicator: 0,
	mapPriceIndicator: 0
};
